module.exports = __webpack_public_path__ + "static/img/birdsbeasts_en.25d7589.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lucas/birdsbeasts_en.png
// module id = ZDGG
// module chunks = 1